import { emptyQuestionDto, QuestionDto } from './questionTypes';
import { ChoiceDto } from './choiceTypes';
import { ColumnAnswerDto } from './columnAnswerTypes';

export interface AnswerDto {
  id?: number,
  question: QuestionDto,
  answer: string,
  choice?: ChoiceDto,
  columnAnswers?: ColumnAnswerDto[],
}

export function getEmptyAnswerDto(): AnswerDto {
  return {
    question: emptyQuestionDto(),
    answer: '',
    choice: undefined,
    columnAnswers: undefined,
  };
}
